import ReadSmore from 'read-smore/dist/index.modern.js'
const readMores = document.querySelectorAll('.collection-description')
ReadSmore(readMores, { wordsCount: 40, isInline: true }).init();